import BaseService from '@src/services/BaseService'

class BusinessUnitCheckService extends BaseService {
    constructor() {
        super('bus-checks')
    }
}

export default new BusinessUnitCheckService();